import { Responsive, useDeviceType } from '@cian/ui-kit';
import { CianLogoSign } from '@cian/ui-kit-design-tokens/logo';
import * as styles from './styles.css';
import { clsx } from 'clsx';
import { TG, VK, YT } from 'shared/constants/links';

export const Header: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <CianLogoSign colorType="onBright" size={24} />
      <Responsive desktop tablet>
        <div className={styles['socials']}>
          <a className={clsx(styles['social'], styles['vk'])} target="_blank" href={VK} rel="noreferrer" />
          <a className={clsx(styles['social'], styles['yt'])} target="_blank" href={YT} rel="noreferrer" />
          <a className={clsx(styles['social'], styles['tg'])} target="_blank" href={TG} rel="noreferrer" />
        </div>
      </Responsive>
    </div>
  );
};
